<template>
  <section class="row">
    <div class="col-12 mx-auto">
      <div class="card shadow">
        <div
          class="card-body px-md-4 py-4 py-md-5
            box-shadow-pink-300 box-shadow-hover-pink-300 rounded-4"
        >
          <div class="row">
            <div class="col-2">
              <v-icon
                icon="chevron-left"
                class="cursor-pointer"
                @click="() => $router.back()"
              />
            </div>
            <div class="col-8">
              <div class="h5 text-center mb-3">
                Informations
              </div>
            </div>
            <div class="col-12 col-md-5 offset-md-1 mb-md-0 mb-2">
              <router-link
                v-slot="{ navigate }"
                to="/client/account/informations/contact"
                custom
              >
                <div
                  class="card cursor-pointer shadow p-4"
                  style="min-height: 300px"
                  @mouseover="contactHover = true"
                  @mouseleave="contactHover = false"
                  @click="navigate"
                >
                  <div class="card-body d-flex flex-column">
                    <span class="text-center lead fw-bold">
                      Personne à contacter
                    </span>
                    <div class="m-auto">
                      <v-icon
                        :icon="`phone-contact${contactHover ? '-off': ''}`"
                        folder="dashboard/svg/account"
                        width="100"
                        height="70"
                      />
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
            <div class="col-12 col-md-5">
              <router-link
                v-slot="{ navigate }"
                to="/client/account/informations/members"
                custom
              >
                <div
                  class="card cursor-pointer shadow p-4"
                  style="min-height: 300px"
                  @mouseover="multiAcccessHover = true"
                  @mouseleave="multiAcccessHover = false"
                  @click="navigate"
                >
                  <div class="card-body d-flex flex-column">
                    <span class="text-center lead fw-bold">
                      Multi accès
                    </span>
                    <div class="m-auto">
                      <v-icon
                        :icon="`team${multiAcccessHover ? '-off': ''}`"
                        folder="dashboard/svg/account"
                        width="100"
                        height="70"
                      />
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AccountInformationsHome',
  data() {
    return {
      contactHover: false,
      multiAcccessHover: false,
    };
  },
};
</script>
